import React, { useEffect } from 'react';
import { Link, useLocation, useParams } from 'react-router-dom';

interface Props {
  id: string | undefined;
}

const EntrevistaDetallesHeader: React.FC<Props> = ({id}) => {
  const location = useLocation();

  return (
    <div className='d-flex overflow-auto h-55px'>
      <ul className='nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bolder flex-nowrap'>
        <li className='nav-item'>
          <Link
            className={
              `nav-link text-active-primary me-6 ` +
              (location.pathname === `/Testimonial/Detalles/${id}` && 'active')
            }
            to={`/Testimonial/Detalles/${id}`}
          >
            Detalles
          </Link>
        </li>
        <li className='nav-item'>
          <Link
            className={
              `nav-link text-active-primary me-6 ` +
              (location.pathname === `/Testimonial/Archivos/${id}` && 'active')
            }
            to={`/Testimonial/Archivos/${id}`}
          >
            Archivos
          </Link>
        </li>
        <li className='nav-item'>
          <Link
            className={
              `nav-link text-active-primary me-6 ` +
              (location.pathname === `/Testimonial/Etiquetas/${id}` && 'active')
            }
            to={`/Testimonial/Etiquetas/${id}`}
          >
            Etiquetas
          </Link>
        </li>
      </ul>
    </div>
  );
}

export {EntrevistaDetallesHeader};